//Local
// export const BASEURL = "https://absoluteweb.org/myjainism/api/public/v1"
//Live
export const BASEURL = "https://myjainism.in/api/public/v1"